import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useLocalStorage } from '@uidotdev/usehooks';

import GameTopBar from 'components/GameTopBar';
import Game from 'components/Game';
import Layout from 'components/Layout';
import { useDaily, useGame } from 'common/state';
import { useGameDataHistory } from 'common/hooks';
import { verifyAndFixGameData } from 'common/logic';

function DailyScreen() {
  const [dailyState, dailyActions] = useDaily();
  const [gameState, gameActions] = useGame();
  const { language } = useParams();
  const { getGameData, updateGameData } = useGameDataHistory();
  const [tutorialDoneIn, setTutorialDoneIn] = useLocalStorage(
    'letroso-tutorial-done-in',
    [],
  );
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!tutorialDoneIn.includes(language)) {
      setTutorialDoneIn([...tutorialDoneIn, language]);
      const timeout = setTimeout(() => {
        setSearchParams({ ...searchParams, open: 'instructions' });
      }, 100);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dailyActions.load(language);
  }, [dailyActions, language]);

  useEffect(() => {
    if (
      dailyState.gameId !== gameState.id ||
      dailyState.language !== gameState.language
    ) {
      const dailyGameData = verifyAndFixGameData(
        dailyState.gameSpec,
        getGameData(dailyState.gameId, dailyState.language),
      );
      gameActions.prepare(
        dailyState.language,
        dailyState.gameId,
        dailyState.date,
        dailyState.gameSpec,
        dailyGameData,
      );
    }
  }, [dailyState, gameState, gameActions, getGameData]);

  useEffect(() => {
    updateGameData(gameState);
  }, [gameState, updateGameData]);

  return (
    <Layout>
      <GameTopBar />
      {gameState.status !== 'unprepared' && <Game />}
    </Layout>
  );
}

export default DailyScreen;
